import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { StoreLandingUrl } from "./helper/store-landing-url";

StoreLandingUrl()

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(<App />)
